// makemyrings | component-collection-stock-navigation.js | 仅横向露出当前分类，支持区块重载，不拦截链接或触摸手势。
(() => {
    if (customElements.get('mmr-stock-navigation')) return;

    class StockNavigation extends HTMLElement {
        connectedCallback() {
            this.rail = this.querySelector('[data-stock-rail]');
            this.current = this.querySelector('[aria-current="page"]');
            if (!this.rail || !this.current) return;

            this.observer?.disconnect();
            this.observer = new ResizeObserver(() => this.revealCurrent());
            this.observer.observe(this.rail);
            this.revealCurrent();
        }

        disconnectedCallback() {
            this.observer?.disconnect();
            this.rail = null;
            this.current = null;
        }

        revealCurrent() {
            if (!this.rail || !this.current || this.rail.scrollWidth <= this.rail.clientWidth) return;
            const rail = this.rail.getBoundingClientRect();
            const current = this.current.getBoundingClientRect();
            // 只设置横向滚动，避免 scrollIntoView 把整页跳到导航位置。
            const left = this.rail.scrollLeft + current.left - rail.left - (this.rail.clientWidth - current.width) / 2;
            this.rail.scrollLeft = Math.max(0, Math.min(left, this.rail.scrollWidth - this.rail.clientWidth));
        }
    }

    customElements.define('mmr-stock-navigation', StockNavigation);
})();
